module.exports = __webpack_public_path__ + "img/hys-2.1411b2ac.webp";